template = require('./portfolio_breakdown.html.slim')
controller = require('./portfolio_breakdown_controller')

angular.module('wbComponents').directive 'wbPortfolioBreakdown', ->
  restrict: 'E'
  replace: true
  scope:
    account: '='
    assetClasses: '='
  templateUrl: template
  controller: controller
  controllerAs: 'ctrl'
  bindToController: true
